import axios from 'axios';

export default axios.create({
  //baseURL: 'http://localhost:3011', // servidor local
  //baseURL: 'https://api.gestcominformatica.com.br',
  //baseURL: 'https://apitocantins.gestcominformatica.com.br',  //TOCANTINS-MG
  //baseURL: 'https://apibraspires.gestcominformatica.com.br', //BRAS PIRES-MG
  baseURL: 'https://apiitabira.gestcominformatica.com.br', //Itabira -MG
});
